import httpClient from '../../utilities/http/http-client';

const endPoint = '/v1/general/media/upload-media';

export default {
  uploadFile(params = {}) {
    return httpClient.post(endPoint, params);
  },
};
